import { Fragment, useEffect, useRef, useState } from 'react';
import { Editor } from '@monaco-editor/react';
import { Box } from '@mui/material';

export const MonacoEditor = (props: Parameters<typeof Editor>[0]) => {
  const [defaultHeight, setDefaultHeight] = useState(200);
  const heightBeaconRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const heightBeacon = heightBeaconRef.current;

    if (heightBeacon) {
      const observer = new ResizeObserver((entries) => {
        const rect = heightBeacon.getBoundingClientRect();
        setDefaultHeight(window.innerHeight - rect.top - 16);
      });

      observer.observe(heightBeacon);

      let parent = heightBeacon.parentElement;
      while (parent) {
        observer.observe(parent);
        parent = parent.parentElement;
      }

      return () => {
        observer.disconnect();
      };
    }
  }, []);

  return (
    <Fragment>
      <Box ref={heightBeaconRef} />
      <Editor {...props} height={props.height ?? defaultHeight} />
    </Fragment>
  );
};
